import { Button } from '../../../ds/components';
import type { MailboxRowData } from '../types';
import styles from './mailbox.module.css';

export interface MailboxRowProps {
  row: MailboxRowData;
  /** Row id while its action runs (buttons wait). */
  busy: boolean;
  /** The disconnected mailbox (After-Sales 02): the row is shown but inert. */
  inert?: boolean | undefined;
  onAssign: (row: MailboxRowData) => void;
  onTicket: (row: MailboxRowData) => void;
  onSearch: (row: MailboxRowData) => void;
}

/**
 * One mail of the support mailbox (After-Sales 01): sender (name or address) · time, subject, one-line preview; on the
 * right the suggestion with „Zuordnen" / „Ticket", or „kein Treffer" with „Kontakt suchen" / „Ticket". Rows that are
 * no longer unassigned show the API's status label instead of the buttons.
 */
export function MailboxRow({ row, busy, inert = false, onAssign, onTicket, onSearch }: MailboxRowProps) {
  const open = row.status === 'unassigned';
  return (
    <li className={styles.row} aria-label={`${row.sender}: ${row.subject}`}>
      <div className={styles.mail}>
        <div className={styles.mailHead}>
          <span className={styles.sender} title={row.senderEmail}>
            {row.sender}
          </span>
          <span className={styles.time}>{row.timeLabel}</span>
        </div>
        <div className={styles.subject}>{row.subject}</div>
        <div className={styles.preview}>{row.preview}</div>
      </div>
      <div className={styles.side}>
        {!open ? (
          <span className={styles.statusLabel}>{row.statusLabel}</span>
        ) : row.suggestion ? (
          <>
            <span className={styles.eyebrow}>Vorschlag</span>
            <span className={styles.suggestion}>{row.suggestion.label}</span>
            <span className={styles.buttons}>
              <Button variant="secondary" size="small" disabled={busy || inert} onClick={() => onAssign(row)}>
                Zuordnen
              </Button>
              <Button variant="secondary" size="small" disabled={busy || inert} onClick={() => onTicket(row)}>
                Ticket
              </Button>
            </span>
          </>
        ) : (
          <>
            <span className={styles.noMatch}>kein Treffer</span>
            <span className={styles.buttons}>
              <Button variant="secondary" size="small" disabled={busy || inert} onClick={() => onSearch(row)}>
                Kontakt suchen
              </Button>
              <Button variant="secondary" size="small" disabled={busy || inert} onClick={() => onTicket(row)}>
                Ticket
              </Button>
            </span>
          </>
        )}
      </div>
    </li>
  );
}
